import { render, staticRenderFns } from "./PublicQuotationPages8.vue?vue&type=template&id=4886c4a8&scoped=true&"
import script from "./PublicQuotationPages8.vue?vue&type=script&lang=js&"
export * from "./PublicQuotationPages8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4886c4a8",
  null
  
)

export default component.exports